import { createApp,ref } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/style/main.css';
import message from "./utils/message";
import alert from "./utils/alert";
import * as turf from "@turf/turf";
import ArcoVue from '@arco-design/web-vue'
// 引入 Arco 样式
import '@arco-design/web-vue/dist/arco.css'
const app = createApp(App);
// 将 AhMessage 注册为全局方法
app.config.globalProperties.$message = message;
app.config.globalProperties.$locss = ref(true);
app.config.globalProperties.$reportNum = ref(true);

// 将 turf 挂载为全局属性
app.config.globalProperties.$turf = turf;

// 注册全局的 Alert 管理器
app.use(alert);
app.use(ArcoVue)

app.use(store).use(router).mount('#app');
